import styled from 'styled-components';
import { colors, radii } from '../../theme/tokens';
import { getStatusBackground, getStatusForeground } from '../../theme/status';
import { getToneBackground, getToneForeground } from '../../theme/tone';

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: ${({ $status }) => getStatusForeground($status)};
  background: transparent;
  padding: 0;
`;

export const ToneTag = styled.span<{ $tone: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ $tone }) => getToneForeground($tone)};
  background: transparent;
  padding: 0;
`;

export const StatusDot = styled.span<{ $status: string }>`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 500;
    color: ${({ $status }) => ($status === 'reviewed' ? '#1a7a4c' : '#8a8a8a')};

    &::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: ${({ $status }) => getStatusForeground($status)};
    }
`;

export const WarningChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: ${radii.sm};
  font-size: 12px;
  background: ${colors.backgroundTones.danger};
  color: ${colors.status.danger};
`;
